<div [ngClass]="{ 'max-w-6xl mx-auto': pageFullWidth && !isFullBleedComponent }">
    <div>
        <vsf-title-box
            [titleInfo]="titleInfo"
            [forSection]="true">
        </vsf-title-box>
    </div>
    <div *ngIf="type === 'marketing-banner'">
        <vsf-marketing-banner
            [titleInfo]="titleInfo"
            [marketingBanner]="marketingBanner"
            [linePadding]="linePadding"
            [sectionRoundedClass]="sectionRoundedClass"
            [isMobile]="isMobile"
            [pageFullWidth]="pageFullWidth"
            [sectionMaxHeight]="sectionMaxHeight"
        >
        </vsf-marketing-banner>
    </div>
    <div *ngIf="type === 'key-point-list'">
        <vsf-key-selling-points-banner
            [titleInfo]="titleInfo"
            [titleFontSize]="keyPointList.titleFontSize"
            [subtitleFontSize]="keyPointList.subtitleFontSize"
            [textFontSize]="keyPointList.textFontSize"
            [titleAlignment]="keyPointList.titleAlignment"
            [textAlignment]="keyPointList.textAlignment"
            [iconSize]="keyPointList.iconSize"
            [keySellingPoints]="keyPointList.keyPoints"
            [layout]="keyPointList.keyPointsLayoutType"
            [mobileLayout]="keyPointList.mobileKeyPointsLayoutType"
            [backgroundColor]="keyPointList.backgroundColor"
            [textColor]="keyPointList.textColor"
            [listLayout]="isMobile?'vertical':'horizontal'"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
            [sectionRoundedClass]="sectionRoundedClass"
        >
        </vsf-key-selling-points-banner>
    </div>
    <div *ngIf="type === 'hero-section'">
        <vsf-hero-section
            [titleInfo]="titleInfo"
            [heroSection]="heroSection"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
            [pageFullWidth]="pageFullWidth"
            [sectionMaxHeight]="sectionMaxHeight"
        >
        </vsf-hero-section>
    </div>
    <div *ngIf="type === 'card-carousel-banner'">
        <vsf-card-carousel-banner
            [titleInfo]="titleInfo"
            [banner]="cardCarouselBanner"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
        >
        </vsf-card-carousel-banner>
    </div>
    <div *ngIf="type === 'external-html-content'">
        <vsf-external-html-content
            [titleInfo]="titleInfo"
            [externalHtmlContent]="externalHtmlContent"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
        >
        </vsf-external-html-content>
    </div>
    <div *ngIf="type === 'faq-list'">
        <vsf-faq-list
            [titleInfo]="titleInfo"
            [faqList]="faqList"
            [linePadding]="linePadding"
        ></vsf-faq-list>
    </div>
    <div *ngIf="type === 'featured-collection'">
        <div *ngIf="!isMobile">
            <div>
                <vsf-product-carousel-v2
                    [titleInfo]="titleInfo"
                    [displayType] = "featuredCollection?.displayType"
                    [productCardType]="featuredCollection?.productCardType"
                    [displayFields]="featuredCollection?.displayFields"
                    [collectionSlug]="featuredCollection?.collection?.slug"
                    [collectionName]="featuredCollection?.collection?.name"
                    [collectionItemOrder]="featuredCollection?.collection?.customFields?.itemOrderData"
                    [channelId]="sellerChannelId"
                    [itemsPerSlide]="featuredCollection?.cardsPerRow"
                    [productCardShape]="featuredCollection?.productCardShape"
                    [displayAlternativeImage]="true"
                    [imgSize]="'md'"
                    [productCardRoundedCorners]="featuredCollection?.productCardRoundedCorners"
                    [buttonText]="featuredCollection?.buttonText"
                    [buttonColorMode]="featuredCollection?.buttonColorMode"
                    [buttonBgColor]="featuredCollection?.buttonBgColor"
                    [buttonTextColor]="featuredCollection?.buttonTextColor"
                    [linePadding]="linePadding">
                </vsf-product-carousel-v2>
            </div>
        </div>
        <div *ngIf="isMobile">
            <ng-container *ngIf="featuredCollection?.productCardType === 'regular'
                                || featuredCollection?.productCardType === 'top-asset-small'
                                || featuredCollection?.productCardType === 'regular-type2'
                                || featuredCollection?.productCardType === 'horizontal-type';
                                else newSwiper ">
                <vsf-product-swiper
                    [titleInfo]="titleInfo"
                    [displayType] = "featuredCollection?.displayType"
                    [productCardType]="featuredCollection?.productCardType"
                    [displayFields]="featuredCollection?.displayFields"
                    [collectionSlug]="featuredCollection?.collection?.slug"
                    [collectionItemOrder]="featuredCollection?.collection?.customFields?.itemOrderData"
                    [channelId]="sellerChannelId"
                    [layoutMode]="'vertical'"
                    [itemsPerRow]="featuredCollection?.mobileCardsPerRow"
                    [itemsPerSlide]=8
                    [productCardShape]="featuredCollection?.productCardShape"
                    [displayPagination]="false"
                    [productCardRoundedCorners]="featuredCollection?.productCardRoundedCorners"
                    [buttonText]="featuredCollection?.buttonText"
                    [buttonColorMode]="featuredCollection?.buttonColorMode"
                    [buttonBgColor]="featuredCollection?.buttonBgColor"
                    [buttonTextColor]="featuredCollection?.buttonTextColor"
                    [imgSize]="'sm-v'"
                    [linePadding]="linePadding">
                </vsf-product-swiper>
            </ng-container>
            <ng-template #newSwiper>
                <vsf-product-swiper-v2
                    [titleInfo]="titleInfo"
                    [displayType] = "featuredCollection?.displayType"
                    [productCardType]="featuredCollection?.productCardType"
                    [displayFields]="featuredCollection?.displayFields"
                    [collectionSlug]="featuredCollection?.collection?.slug"
                    [collectionItemOrder]="featuredCollection?.collection?.customFields?.itemOrderData"
                    [channelId]="sellerChannelId"
                    [layoutMode]="'vertical'"
                    [itemsPerRow]="featuredCollection?.mobileCardsPerRow"
                    [itemsPerSlide]=4
                    [displayPagination]="false"
                    [productCardRoundedCorners]="featuredCollection?.productCardRoundedCorners"
                    [buttonText]="featuredCollection?.buttonText"
                    [buttonColorMode]="featuredCollection?.buttonColorMode"
                    [buttonBgColor]="featuredCollection?.buttonBgColor"
                    [buttonTextColor]="featuredCollection?.buttonTextColor"
                    [imgSize]="'sm-v'"
                    [linePadding]="linePadding">
                </vsf-product-swiper-v2>
            </ng-template>
        </div>
    </div>
    <div *ngIf="type === 'collection-group'">
        <div *ngIf="isMobile">
            <vsf-collection-group-swiper
                [titleInfo]="titleInfo"
                [collectionGroup]="collectionGroup"
                [displayPagination]=true
                [linePadding]="linePadding">
            </vsf-collection-group-swiper>
        </div>
        <div *ngIf="!isMobile">
            <vsf-collection-group-carousel
                [titleInfo]="titleInfo"
                [collectionGroup]="collectionGroup"
                [linePadding]="linePadding">
            </vsf-collection-group-carousel>
        </div>
    </div>
    <div *ngIf="type === 'email-subscription'">
        <vsf-email-subscription-form
            [titleInfo]="titleInfo"
            [linePadding]="linePadding"
            [emailSubscriptionData]="emailSubscriptionSection">
        </vsf-email-subscription-form>
    </div>
    <div *ngIf="type === 'top-reviews'">
        <vsf-top-reviews
            [titleInfo]="titleInfo"
            [topReviews]="topReviews"
            [isMobile]="isMobile"
            [linePadding]="linePadding">
        </vsf-top-reviews>
    </div>
    <div *ngIf="type === 'product-listing-section' && sellerChannelId">
        <vsf-product-list
            [titleInfo]="titleInfo"
            [linePadding]="linePadding"
            [channelId]="sellerChannelId"
            [storeSiteCollectionSlug]="productListing?.productListingType === 'collection' ? productListing?.collection?.slug : ''">
        </vsf-product-list>
    </div>
    <div *ngIf="type === 'product-info-section'">
        <vsf-product-info
            [titleInfo]="titleInfo"
            [linePadding]="linePadding"
            [isProductPage]="false"
            [product]="productInfoProduct"
            [selectedVariant]="productInfoVariant"
            [isMobile]="isMobile"
            [arrowType]="pdpAssetsArrowType">
        </vsf-product-info>
    </div>
    <div *ngIf="type === 'simple-product-info-section'">
        <vsf-product-info
            [titleInfo]="titleInfo"
            [linePadding]="linePadding"
            [isProductPage]="false"
            [product]="simpleProductInfo?.productVariant?.product"
            [selectedVariant]="simpleProductInfo?.productVariant"
            [isMobile]="isMobile"
            [arrowType]="pdpAssetsArrowType"
            [displayThumbnails]="simpleProductInfo?.displayThumbnails"
            [displayFeaturedReview]="simpleProductInfo?.displayFeaturedReview"
            [displayProductSubtitle]="simpleProductInfo?.displayProductSubtitle"
            [displaySku]="simpleProductInfo?.displaySku"
            [displayReviewInfo]="simpleProductInfo?.displayReviewInfo"
            [displayPaymentCapabilities]="simpleProductInfo?.displayPaymentCapabilities"
            [displayProductOptions]="simpleProductInfo?.displayProductOptions"
            [displayProductDescription]="simpleProductInfo?.displayProductDescription"
            [displayAddToCart]="simpleProductInfo?.displayAddToCart"
            [displayProductKeyPoints]="simpleProductInfo?.displayProductKeyPoints"
            [displayProductFeatures]="simpleProductInfo?.displayProductFeatures"
            [displayProductPageEntry]="simpleProductInfo?.displayProductPageEntry"
        >
        </vsf-product-info>
    </div>
    <div *ngIf="type === 'collection-carousel'">
        <div *ngIf="isMobile">
            <ng-container *ngIf="collectionCarousel.mobileStyle === 'slide'">
                <vsf-dual-collections-swiper
                    [titleInfo]="titleInfo"
                    [linePadding]="linePadding"
                    [collectionsList]="collectionCarousel.collections"
                >
                </vsf-dual-collections-swiper>
            </ng-container>
            <ng-container *ngIf="collectionCarousel.mobileStyle === 'tiles'">
                <vsf-dual-collections-tiles
                    [titleInfo]="titleInfo"
                    [linePadding]="linePadding"
                    [collectionsList]="collectionCarousel.collections"
                >
                </vsf-dual-collections-tiles>
            </ng-container>
        </div>
        <div *ngIf="!isMobile">
            <vsf-collections-carousel
                [titleInfo]="titleInfo"
                [linePadding]="linePadding"
                [textAlignment]="collectionCarousel.textAlignment"
                [collectionsList]="collectionCarousel.collections">
            </vsf-collections-carousel>
        </div>
    </div>
    <div *ngIf="type === 'about-form'">
        <vsf-about-form
            [titleInfo]="titleInfo"
            [aboutForm]="aboutForm"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
        ></vsf-about-form>
    </div>
    <div *ngIf="type === 'contact-form'">
        <vsf-contact-form
            [titleInfo]="titleInfo"
            [contactForm]="contactForm"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
        ></vsf-contact-form>
    </div>
    <div *ngIf="type === 'product-reviews'">
        <vsf-porduct-review-section
            [titleInfo]="titleInfo"
            [productReviews]="productReviews"
            [isMobile]="isMobile"
            [linePadding]="linePadding"
            [horizontalPadding]="horizontalPadding">
        </vsf-porduct-review-section>
    </div>
</div>
